/**
 * キーカラー導出モジュール
 *
 * プライマリカラーからセカンダリ/ターシャリを導出する機能を提供。
 *
 * @module @/core/key-color-derivation
 */

export { deriveSecondaryTertiary } from "./deriver";
export * from "./types";
